document.addEventListener('DOMContentLoaded', function () {
  setInterval(function () {
    $('.row.row-0.products.products-grid.grid-4.layout-2.slick-initialized.slick-slider.slick-dotted').slick('refresh')
  }, 1500);

  setTimeout(function () {
    if (window.location.href.indexOf('#') > -1) {
      const needid = window.location.href.split('#')[1];
      const elementToScrollTo = document.getElementById(needid);

      if (document.querySelector(`[href="#${needid}"]`)) {
        document.querySelector(`[href="#${needid}"]`).click();
      }

      setTimeout(function () {
        if (elementToScrollTo) {
          const rect = elementToScrollTo.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          window.scrollTo({
            top: rect.top + scrollTop - 150,
            behavior: 'smooth'
          });
        }
      }, 300)
    }
  }, 500);
})

class ProductMinOrder {
  constructor() {
    this.container = document.querySelector('.product-template__container[data-min-order]');
    if (!this.container) return;

    this.minOrder = Number(this.container.dataset.minOrder || 1);
    this.submitButton = this.container.querySelector('[name="add"]');
    this.oneClickButton = this.container.querySelector('.product-buy__1click');
    this.quantityInput = this.container.querySelector('[name="quantity"]');
    this.messageEl = this.container.querySelector('[data-min-order-message]');
    this.currentVariant = null;
    this.cartItems = [];
    
    const variantsDataEl = document.querySelector('[data-variants-inventory]');
    if (variantsDataEl) {
      try {
        this.productData = JSON.parse(variantsDataEl.textContent);
      } catch (e) {
        console.warn('Failed to parse variants inventory data:', e);
        this.productData = [];
      }
    } else {
      console.warn('Variants inventory data element not found');
      this.productData = [];
    }

    this.translations = window.theme && window.theme.strings ? window.theme.strings : {};

    this.initProductData();
    this.loadCartData();
    this.bindEvents();
    this.checkConditions();
  }

  async loadCartData() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.cartItems = cart.items || [];
      this.checkConditions();
    } catch (e) {
      console.warn('Failed to load cart data:', e);
      this.cartItems = [];
    }
  }

  getCartQuantityForVariant(variantId) {
    if (!variantId || !Array.isArray(this.cartItems)) return 0;
    const cartItem = this.cartItems.find(item => item.variant_id === variantId);
    return cartItem ? cartItem.quantity : 0;
  }

  initProductData() {
    try {
      const sectionId = this.container.getAttribute('data-section-id');
      const variantSelect = this.container.querySelector(`select[name="id"].ProductSelect-${sectionId}`);

      const selectedVariantId = variantSelect ? Number(variantSelect.value) : Number(this.container.dataset.variantId);
      if (!selectedVariantId || !Array.isArray(this.productData)) {
        console.warn('Invalid variant ID or product data:', { selectedVariantId, productData: this.productData });
        this.currentVariant = null;
        return;
      }
  
      this.currentVariant = this.productData.find(v => v.id === selectedVariantId) || null;
      
      if (!this.currentVariant) {
        console.warn('Variant not found in product data:', selectedVariantId);
      }
    } catch (e) {
      console.warn('Failed to initialize product data:', e);
      this.currentVariant = null;
    }
  }
  

  bindEvents() {
    if (!this.quantityInput) return;

    this.quantityInput.addEventListener('input', () => {
      this.checkConditions();
    });

    this.quantityInput.addEventListener('change', () => {
      this.checkConditions();
    });

    if (this.container) {
      const sectionId = this.container.getAttribute('data-section-id');
      const variantSelect = this.container.querySelector(`select[name="id"].ProductSelect-${sectionId}`);
      
      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          this.updateVariantFromSelect();
        });
      }

      this.container.addEventListener('variantChange', (evt) => {
        if (evt.variant) {
          this.currentVariant = evt.variant;
          this.checkConditions();
        }
      });

      document.addEventListener('click', (evt) => {
        const target = evt.target;
        if (target && (target.classList.contains('plus') || target.classList.contains('minus'))) {
          const quantityWrapper = target.closest('.product-form__item--quantity');
          if (quantityWrapper && this.container.contains(quantityWrapper)) {
            this.handleQuantityChange();
          }
        }
      });

      const productForm = this.container.querySelector('form[action="/cart/add"]');
      if (productForm) {
        productForm.addEventListener('submit', () => {
          setTimeout(() => {
            this.loadCartData();
          }, 500);
        });
      }

      document.addEventListener('cart:updated', () => {
        this.loadCartData();
      });

      window.addEventListener('focus', () => {
        this.loadCartData();
      });
    }
  }

  updateVariantFromSelect() {
    try {
      const sectionId = this.container.getAttribute('data-section-id');
      const variantSelect = this.container.querySelector(`select[name="id"].ProductSelect-${sectionId}`);
      
      if (!variantSelect || !Array.isArray(this.productData)) {
        this.currentVariant = null;
        return;
      }

      const selectedVariantId = Number(variantSelect.value);
      this.currentVariant = this.productData.find(v => v.id === selectedVariantId) || null;
      this.checkConditions();
    } catch (e) {
      console.warn('Failed to update variant from select:', e);
      this.currentVariant = null;
    }
  }

  handleQuantityChange() {
    setTimeout(() => {
      this.checkConditions();
    }, 10);
  }

  checkConditions() {
    const qty = Number(this.quantityInput?.value || 0);
    const inventory = this.currentVariant ? this.currentVariant.inventory_quantity : 0;
    const variantId = this.currentVariant ? this.currentVariant.id : null;
    const cartQty = this.getCartQuantityForVariant(variantId);
    
    const availableInventory = Math.max(0, inventory - cartQty);
    const totalQty = qty + cartQty;
    const maxAllowedQty = availableInventory;
    
    if (qty > maxAllowedQty && this.quantityInput && maxAllowedQty > 0) {
      this.quantityInput.value = maxAllowedQty;
      return this.checkConditions();
    }

    const hasEnoughTotal = totalQty >= this.minOrder;
    const valid = hasEnoughTotal && qty > 0 && qty <= maxAllowedQty;
    
    const needsMoreItems = totalQty < this.minOrder;
    const itemsNeeded = Math.max(0, this.minOrder - totalQty);
    
    const isOutOfStock = availableInventory <= 0 || (inventory > 0 && inventory <= cartQty);
  
    this.updateMessage(needsMoreItems, itemsNeeded, isOutOfStock, cartQty);
    this.buttonsState(valid);
    this.updateOutOfStockState(isOutOfStock);
    
    if (isOutOfStock) {
      this.stateOtherSections(false);
    } else {
      this.stateOtherSections(true);
    }
  }

  updateMessage(needsMoreItems, itemsNeeded, isOutOfStock, cartQty) {
    if (!this.messageEl) return;

    let message = '';
    
    if (isOutOfStock) {
      this.messageEl.setAttribute('data-out-of-stock', 'true');
    } else {
      this.messageEl.removeAttribute('data-out-of-stock');
      
      if (needsMoreItems && this.minOrder > 1) {
        const template = this.translations.minOrderAddMore || 'Add {{ count }} more item(s) to cart to complete your order';
        message = template.replace('{{ count }}', itemsNeeded);
      }
    }

    if (message && message !== '') {
      this.messageEl.textContent = message;
      this.messageEl.style.display = 'block';
    } else {
      this.messageEl.style.display = 'none';
    }
  }

  updateOutOfStockState(isOutOfStock) {
    if (!this.container) return;

    const sectionId = this.container.getAttribute('data-section-id');
    const addToCartText = this.container.querySelector(`.AddToCartText-${sectionId}`);
    const quantityWrapper = this.container.querySelector('.product-form__item--quantity');
    
    if (isOutOfStock) {
      if (addToCartText && this.translations.soldOut) {
        addToCartText.textContent = this.translations.soldOut;
      }
      if (quantityWrapper) {
        quantityWrapper.classList.add('btn-disabled');
      }
      if (this.submitButton) {
        this.submitButton.disabled = true;
      }
    } else {
      if (addToCartText && this.translations.addToCart) {
        addToCartText.textContent = this.translations.addToCart;
      }
      if (quantityWrapper) {
        quantityWrapper.classList.remove('btn-disabled');
      }
    }
  }

  stateOtherSections(state) {
    const otherSections = document.querySelectorAll('.product-single__stock');
    otherSections.forEach(section => {
      section.style.display = state ? 'block' : 'none';
    });
  }

  buttonsState(status) {
    const disable = !status;
    if (this.submitButton) {
      this.submitButton.disabled = disable;
      this.submitButton.style.opacity = disable ? '0.5' : '1';
      this.submitButton.style.cursor = disable ? 'not-allowed' : 'pointer';
      this.submitButton.style.pointerEvents = disable ? 'none' : 'auto';
    }
    if (this.oneClickButton) {
      this.oneClickButton.disabled = disable;
      this.oneClickButton.style.display = disable ? 'none' : 'inline-flex';
    }
  }
}

new ProductMinOrder();
